import permissions from '../../data/permissions';

export default [
    {
        name: "LandedCostComponentList",
        path: "landed-cost-components",
        component: () => import('./../../views/purchase/LandedCostComponentListView.vue'),
        meta: { requiresAuth: true, authorization: permissions.landed_cost_component.index }
    },
    {
        name: "LandedCostComponentCreate",
        path: "landed-cost-component",
        component: () => import('./../../views/purchase/LandedCostComponentCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.landed_cost_component.create }
    },
    {
        name: "LandedCostComponentDisplay",
        path: "landed-cost-component/:id",
        component: () => import('./../../views/purchase/LandedCostComponentDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.landed_cost_component.read }
    },
    {
        name: "LandedCostComponentEdit",
        path: "landed-cost-component/:id/edit",
        component: () => import('./../../views/purchase/LandedCostComponentEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.landed_cost_component.update }
    }
]